"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    resize: prop_types_1.default.string
};
exports.propAliases = {};
exports.propValidators = {};
const resize = {
    className: 'rsz',
    cssName: 'resize',
    jsName: 'resize'
};
exports.propEnhancers = {
    resize: (value) => get_css_1.default(resize, value)
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzaXplLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2VuaGFuY2Vycy9yZXNpemUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSw0REFBa0M7QUFDbEMseURBQStCO0FBR2xCLFFBQUEsU0FBUyxHQUFxQjtJQUN6QyxNQUFNLEVBQUUsb0JBQVMsQ0FBQyxNQUFNO0NBQ3pCLENBQUE7QUFFWSxRQUFBLFdBQVcsR0FBRyxFQUFFLENBQUE7QUFFaEIsUUFBQSxjQUFjLEdBQW1CLEVBQUcsQ0FBQTtBQUVqRCxNQUFNLE1BQU0sR0FBRztJQUNiLFNBQVMsRUFBRSxLQUFLO0lBQ2hCLE9BQU8sRUFBRSxRQUFRO0lBQ2pCLE1BQU0sRUFBRSxRQUFRO0NBQ2pCLENBQUE7QUFFWSxRQUFBLGFBQWEsR0FBa0I7SUFDMUMsTUFBTSxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDO0NBQ2hFLENBQUEifQ==